import { useAnimation, motion } from 'framer-motion'
import { useState, useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import helperFunctions from '../../../utils/helperFunctions'
import { Filters } from '../../core/filters/Filters'
import NextLink from 'next/link' // alias of Link
import { Image } from '../../core/image/Image'
import { Text } from '../../core/text/Text'
import s from './DumbArticle.module.scss'
import c from 'classnames'

export default function DumbArticle({
    imgSrc,
    tag,
    date,
    title,
    paragraph,
    first = false,
    link,
    mobile = false,
    className,
    smallText = false,
    ...props
}) {
    const [ref, inView] = useInView()

    const [loaded, setLoaded] = useState(false)

    date = helperFunctions.getDate(new Date(date))
    const animationControls = useAnimation()
    const animationVariants = {
        visible: { opacity: 1 },
        hidden: { opacity: 0 },
    }
    //

    useEffect(() => {
        if (inView && loaded) {
            animationControls.start('visible')
        }
    }, [inView, loaded])

    let base = imgSrc + (first ? '&w=641' : '&w=306')
    let base2x = imgSrc + (first ? `&w=${641 * 2}` : `&w=${306 * 2}`)
    let base3x = imgSrc + (first ? `&w=${641 * 3}` : `&w=${306 * 3}`)

    let srcset = base + ' 1x, ' + base2x + ' 2x, ' + base3x + ' 3x'

    return (
        <NextLink href={link} legacyBehavior>
            <motion.div
                initial={'hidden'}
                animate={animationControls}
                variants={animationVariants}
                transition={{
                    ease: 'easeOut',
                    duration: 1,
                }}
                className={c(s.dumbArticle, className)}
                ref={ref}
                {...props}
            >
                <div className={s.imageOF}>
                    <Image
                        src={imgSrc}
                        // width={641}
                        srcSet={!mobile && tag !== 'Hlaðvarp' && srcset}
                        onLoad={() => {
                            setLoaded(true)
                        }}
                    />
                </div>

                <div className={s.dumbArticle__info}>
                    <Filters filterNames={[tag]} />
                    {tag !== 'blog' && date && (
                        <Text className={s.date} variant="date">
                            {date}
                        </Text>
                    )}
                </div>
                <Text variant={first && !smallText ? 'h2' : 'h3'}>{title}</Text>
                <Text variant="p" className={s.paragraph}>
                    {paragraph}
                </Text>
            </motion.div>
        </NextLink>
    )
}
